export function parseResponseTimeHours(draft: string): number | null {
	const hours = Number(draft.trim())
	if (draft.trim() === "" || !Number.isInteger(hours) || hours < 1) return null
	return hours
}
